exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table-container[data-v-0b4ec471]{max-height:400px;overflow:auto}", ""]);

// exports
